"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterByParentXment = exports.getSplitFiltersWithExcludedFiltersForTracking = exports.getSplitFiltersWithAllFilterTypes = exports.getSplitFilters = exports.formatFilters = exports.splitOutBoostedFilters = exports.getFilterArray = exports.getAdvancedFilterArray = void 0;
// TODO: All of this needs to be refactored to stop mutating temporary query objects with [key] assignment expresisons.
var getAdvancedFilterArray = function (performerRequestFilters) {
    if (!(performerRequestFilters === null || performerRequestFilters === void 0 ? void 0 : performerRequestFilters.advanced)) {
        return [];
    }
    var advancedFilters = performerRequestFilters.advanced
        // Don't include a filter field if no options are checked.
        .filter(function (filter) { return filter.options.filter(function (option) { return option.isChecked; }).length > 0; })
        // Convert advanced filter to IPerformerFilter
        .reduce(function (list, filter) {
        // This has to be totally broken, right? currentValue would be an array, not a filter.
        return __spreadArray(__spreadArray([], __read(list), false), [
            {
                name: filter.name,
                value: Object.keys(filter.options
                    .filter(function (option) { return option.isChecked; })
                    .reduce(function (set, option) {
                    // TODO: Gross. This should be side-effect free.
                    option.value.split(",").forEach(function (value) { return (set[value] = true); });
                    return set;
                }, {})).join(),
                isBoosted: false,
                isLocked: filter.isLocked,
                parentXment: filter.parentXment,
            },
        ], false);
    }, []);
    return advancedFilters;
};
exports.getAdvancedFilterArray = getAdvancedFilterArray;
var getFilterArray = function (performerRequestFilters) {
    // Weird way to do null/undefined. Unsure why this would ever be a non-object.
    return performerRequestFilters === null || typeof performerRequestFilters !== "object"
        ? []
        : Object.values(performerRequestFilters)
            .filter(function (filter) { return filter !== undefined; }) // Only include defined filters
            .reduce(function (accumulator, filterSet) { return accumulator.concat(filterSet.filters); }, [])
            .filter(function (filter) { return typeof filter === "object"; })
            .concat((0, exports.getAdvancedFilterArray)(performerRequestFilters));
};
exports.getFilterArray = getFilterArray;
var splitOutBoostedFilters = function (performerFilters) {
    var result = {
        boostedFilters: [],
        unboostedFilters: [],
    };
    if (!Array.isArray(performerFilters) || performerFilters.length === 0) {
        return result;
    }
    result.boostedFilters = performerFilters.filter(function (filter) { return filter.isBoosted; });
    result.unboostedFilters = performerFilters.filter(function (filter) { return !filter.isBoosted; });
    return result;
};
exports.splitOutBoostedFilters = splitOutBoostedFilters;
// @return string with format 'name0:value0;name1:value1;...'
var formatFilters = function (performerFilters) {
    if (!Array.isArray(performerFilters) || performerFilters.length === 0) {
        return "";
    }
    return performerFilters.map(function (filter) { return "".concat(filter.name, ":").concat(filter.value); }).join(";");
};
exports.formatFilters = formatFilters;
var getSplitFilters = function (performerFilters) {
    if (!performerFilters) {
        return {
            filters: "",
            boostedFilters: "",
        };
    }
    var splitFilters = (0, exports.splitOutBoostedFilters)((0, exports.getFilterArray)(performerFilters));
    return {
        filters: (0, exports.formatFilters)(splitFilters.unboostedFilters),
        boostedFilters: (0, exports.formatFilters)(splitFilters.boostedFilters),
    };
};
exports.getSplitFilters = getSplitFilters;
var getSplitFiltersWithAllFilterTypes = function (searchFilters) {
    return __assign(__assign({}, (0, exports.getSplitFilters)(searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.filters)), { excludedFilters: (0, exports.formatFilters)((0, exports.getFilterArray)(searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.excludedFilters)), notExactBoostedFilters: (0, exports.formatFilters)((0, exports.getFilterArray)(searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.notExactBoostedFilters)) });
};
exports.getSplitFiltersWithAllFilterTypes = getSplitFiltersWithAllFilterTypes;
var filterStringToObject = function (filterString) {
    var filtersObject = {};
    filterString
        .split(";")
        .filter(function (filterString) {
        return !!filterString;
    })
        .map(function (filterString) {
        var filterParts = filterString.split(":");
        filtersObject[filterParts[0]] = filterParts[1].split(",");
    });
    // TODO: All of these these interfaces need to be decomposed.
    return filtersObject;
};
var getSplitFiltersWithExcludedFiltersForTracking = function (searchFilters) {
    var searchQueryParams = (0, exports.getSplitFiltersWithAllFilterTypes)(searchFilters);
    Object.entries(searchQueryParams).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        searchQueryParams[key] = filterStringToObject(value);
    });
    return searchQueryParams;
};
exports.getSplitFiltersWithExcludedFiltersForTracking = getSplitFiltersWithExcludedFiltersForTracking;
var filterByParentXment = function (filter, xmentService) {
    var e_1, _a;
    if (!filter.parentXment || filter.parentXment.length === 0) {
        // if no parent xments listed then always include
        return true;
    }
    try {
        for (var _b = __values(filter.parentXment), _c = _b.next(); !_c.done; _c = _b.next()) {
            var xment = _c.value;
            // Include filter if any parent variation matches
            if ((xmentService === null || xmentService === void 0 ? void 0 : xmentService.isXmentVariationOn(xment)) || (xmentService === null || xmentService === void 0 ? void 0 : xmentService.isNoStoreXmentOn(xment))) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
};
exports.filterByParentXment = filterByParentXment;
//# sourceMappingURL=SearchFilters.js.map